import { Col, Container, Row } from 'react-bootstrap';
import Mission_animation from '../../animations/mission_animation/Mission_animation';
import Common_section_heading from '../../common_components/common_heading/common_section_heading/Common_section_heading';
import animationMissionData from "../../animations/mission_animation/Mission_animation.json";
import animationVissionData from "../../animations/mission_animation/Vision_animation.json";
import "./Vision.css";

const Vision = () => {
    return (
        <section className='vision_section section_margin'>
            <Container>
                <Common_section_heading title="VISION & MISSION" subTitle="Guided by purpose, driven by innovation, and committed to empowering every user" />
                <Row>
                    <Col md={6}>
                        <div className='box'>
                            <div className='vision_box'>
                                <div className='lottie'>
                                    <Mission_animation animationData={animationVissionData} />

                                    <h4 className='vision_title'>OUR VISION</h4>
                                </div>
                                <p className='vision_text'>
                                    We envision a world where digital payments are effortless for everyone. By leveraging cutting-edge
                                    technology and a user-friendly interface, we want to become the go-to platform for all recharges and payments.
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className='box'>
                            <div className='vision_box '>
                                <div className='lottie'>
                                    <Mission_animation animationData={animationMissionData} />

                                    <h4 className='vision_title'>OUR MISSION</h4>
                                </div>
                                <p className='vision_text'>
                                    We envision a world where digital payments are effortless for everyone. By leveraging cutting-edge
                                    technology and a user-friendly interface, we want to become the go-to platform for all recharges and payments.
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section >
    )
}

export default Vision;